import { PanelLeft } from 'lucide-react';
import { IconButton, Tooltip } from '@strivelabs/ui-core/v2';
import { useSidebar } from '@strivelabs/ui-blocks/v2';

/**
 * Collapse affordance. The ⌘B shortcut itself is owned by the Sidebar shell, so
 * this only exposes it to the pointer and announces the state.
 */
export function CollapseToggle() {
  const { collapsed, toggleCollapsed } = useSidebar();
  const label = collapsed ? 'Expand sidebar' : 'Collapse sidebar';

  return (
    <Tooltip label={label} shortcut="⌘B" side="right">
      <IconButton aria-label={label} aria-expanded={!collapsed} onClick={toggleCollapsed}>
        <PanelLeft size={16} />
      </IconButton>
    </Tooltip>
  );
}
